import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import {
  Button,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuList,
  Paper,
  Popper,
  Theme,
  Typography,
} from '@material-ui/core';
import { SelectIcon } from 'asset/images';
import { PageReturnOptions } from 'components/SelectOptions';
import { PageReturnSelectProps } from 'components/Select/type';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '167px',
    border: '1px solid #b6b6b6',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: '116px',
    },
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
  },
  paper: {
    width: '167px',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: '116px',
    },
  },
}));

function PageReturnSelect({ returnCount, onChangeReturnCount }: PageReturnSelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography>{returnCount}개</Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <PageReturnOptions
                    returnCount={returnCount}
                    onClose={onCloseMenu}
                    onChangeReturnCount={onChangeReturnCount}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default PageReturnSelect;
